import React, { useState, useRef, useEffect } from 'react';
import GoogleMapReact from 'google-map-react';
import { graphql, useStaticQuery } from 'gatsby';
import LocationTable from '../locationTable/locationTable';
import { locationCountries, LocationTypes } from '../../constants';
import * as Styled from './locationDefaultStyle';
import IconIconMapPinBranch from '../../images/icon-map-pin-branch.png';
import IconMapPinCardlockPC from '../../images/icon-map-pin-cardlock-pc.png';
import IconMapPinCardlockUm from '../../images/icon-map-pin-cardlock-um.png';
import LocationMarker from '../locationMarker/locationMarker';
import iconPinBoth from '../../images/icon-map-pin-branch-cardlock.png';
import IconCheckBoxActive from '../../images/icon-checkbox-active.png';
import IconCheckBoxInActive from '../../images/icon-checkbox-inactive.png';
import IconArrowYellowRight from '../../images/icon-arrow-yellow-right.png';
import Cookies from 'universal-cookie';
import { useTranslation } from 'react-i18next';
import { addTrailingSlash, isSmallDevice } from '../../utils';
import { Helmet } from 'react-helmet';
import ogLogo from '../../images/og-logo.jpg';

const LocationDefault = ({ selectedLanguage, selectedRegion }) => {
  console.log('Language and regions:', selectedLanguage, selectedRegion);
  const locationDataQuery = useStaticQuery(graphql`
    query locationDataMyQuery1 {
      allContentfulLocation(
        filter: {
          brand: { brand: { in: ["Ultramar", "Pipeline Commercial"] } }
        }
      ) {
        edges {
          node {
            node_locale
            address1
            branchHours
            cardlockHours
            branchManager
            id
            location
            city
            province
            urlSlug
            postalCode
            latitude
            longitude
            phone
            email
            type {
              type
            }
            pinType {
              type
            }
            summerHours
            serviceArea {
              serviceArea
            }
            hasHeatingOil
            hasDiesel
            hasGasoline
            hasPropane
            hasLubricants
            hasHeatingEquipment
            hasDef
            hasMarkedDiesel
            hasRestaurant
            hasRestrooms
            hasShowers
            hasWifi
            hasParking
            hasMultiServices
            hasLunchCounter
            hasDriversLounge
            hasConvenienceStore
            pageTitle
            brand {
              brand
              creditColour
              creditText {
                creditText
              }
              creditLogo {
                file {
                  url
                }
              }
            }
          }
        }
      }
    }
  `);

  const cookies = new Cookies();
  const [translation] = useTranslation();
  const [selectedProvince, setSelectedProvince] = useState(
    selectedRegion
  );

  let locationQueryData =
    locationDataQuery?.allContentfulLocation?.edges.filter(
      (edge) => edge?.node?.node_locale === selectedLanguage
    );

  console.log('find selected province: ', selectedProvince);
  if (selectedProvince !== locationCountries[0]) {
    locationQueryData = locationQueryData?.filter(
      (data) => data.node.province === selectedProvince
    );
  }
  const [locationsData, setLocationsData] = useState(locationQueryData);

  const [lat, setLat] = useState(
    parseFloat(locationsData[0]?.node?.latitude) || null
  );
  const [lng, setLng] = useState(
    parseFloat(locationsData[0]?.node?.longitude) || null
  );
  const [currentMarker, setCurrentMarker] = useState('');
  const [zoom, setZoom] = useState(6);
  const [showChooseOffering, setShowChooseOffering] = useState(false);
  const [showLocationTypes, setShowLocationTypes] = useState(
    isSmallDevice() ? false : true
  );
  const [showLocalBranchesMarkers, setShowLocalBranchesMarkers] =
    useState(true);
  const [showUltramarCardlockMarkers, setShowUltramarCardlockMarkers] =
    useState(true);
  const [showPipelineCardlockMarkers, setShowPipelineCardlockMarkers] =
    useState(true);
  const input = useRef(null);
  const [selectedOfferingProducts, setSelectedOfferingProducts] = useState([]);
  const [selectedOfferingServices, setSelectedOfferingServices] = useState([]);

  const offeringProduct = [
    translation('Gasoline'),
    translation('Diesel'),
    translation('MarkedDiesel'),
    translation('Propane'),
    translation('Def'),
    translation('Lubricants'),
    translation('HeatingOil'),
    translation('HeatingEquipment'),
  ];
  const offeringServices = [
    translation('Showers'),
    translation('Restroom'),
    translation('Wi-Fi'),
    translation('Parking'),
    translation('Restaurant'),
    translation('ConvenienceStore'),
    translation('LunchCounter'),
    translation('DriversLounge'),
    translation('Multiservices'),
  ];

  const getMarkerIcon = (types) => {
    let markerIcon = null;
    if (types.length > 1) {
      if (markerIcon == null) {
        markerIcon = iconPinBoth;
      }
    } else {
      types.forEach((locationType) => {
        if (locationType.type === LocationTypes.Branch) {
          if (showLocalBranchesMarkers && markerIcon == null) {
            markerIcon = IconIconMapPinBranch;
          }
        }
        if (locationType.type === LocationTypes.UltramarCardlock) {
          if (showUltramarCardlockMarkers && markerIcon == null) {
            markerIcon = IconMapPinCardlockUm;
          }
        }
        if (locationType.type === LocationTypes.PipelineCardlock) {
          if (showPipelineCardlockMarkers) {
            markerIcon = IconMapPinCardlockPC;
          }
        }
      });
    }
    return markerIcon;
  };

  const searchByCityNameOrPostalCode = (searchText) => {
    // setSelectedProvince(locationCountries[0]);
    const searchResult = locationsData.find(
      (item) =>
        item?.node?.city?.toLowerCase() === searchText ||
        item?.node?.postalCode?.toLowerCase() === searchText ||
        item?.node?.location?.toLowerCase() === searchText
    );
    if (searchResult) {
      setLat(parseFloat(searchResult.node.latitude));
      setLng(parseFloat(searchResult.node.longitude));
      !isSmallDevice() ? setZoom(10) : setZoom(8);
    } else {
      // eslint-disable-next-line no-undef
      const geocoder = new google.maps.Geocoder();
      geocoder.geocode({ address: searchText }, function (results, status) {
        if (status === 'OK') {
          setLat(results[0].geometry.location.lat());
          setLng(results[0].geometry.location.lng());
          !isSmallDevice() ? setZoom(10) : setZoom(8);
        }
      });
    }
  };
  useEffect(() => {
    let result = locationQueryData;
    if (!showLocalBranchesMarkers) {
      result = result?.filter(
        (data) =>
          data.node.pinType[0].type !== LocationTypes.Branch ||
          data.node.pinType.length > 1
      );
    }
    if (!showUltramarCardlockMarkers) {
      result = result?.filter(
        (data) =>
          data.node.pinType[0].type !== LocationTypes.UltramarCardlock ||
          data.node.pinType.length > 1
      );
    }
    if (!showPipelineCardlockMarkers) {
      result = result?.filter(
        (data) => data.node.pinType[0].type !== LocationTypes.PipelineCardlock
      );
    }
    if (!showLocalBranchesMarkers && !showUltramarCardlockMarkers) {
      result = result?.filter((data) => data.node.pinType.length === 1);
    }
    if (selectedOfferingProducts.includes(translation('Gasoline'))) {
      result = result?.filter((data) => data.node.hasGasoline === true);
    }
    if (selectedOfferingProducts.includes(translation('Diesel'))) {
      result = result?.filter((data) => data.node.hasDiesel === true);
    }
    if (selectedOfferingProducts.includes(translation('MarkedDiesel'))) {
      result = result?.filter((data) => data.node.hasMarkedDiesel === true);
    }
    if (selectedOfferingProducts.includes(translation('Propane'))) {
      result = result?.filter((data) => data.node.hasPropane === true);
    }
    if (selectedOfferingProducts.includes(translation('Def'))) {
      result = result?.filter((data) => data.node.hasDef === true);
    }
    if (selectedOfferingProducts.includes(translation('Lubricants'))) {
      result = result?.filter((data) => data.node.hasLubricants === true);
    }
    if (selectedOfferingProducts.includes(translation('HeatingOil'))) {
      result = result?.filter((data) => data.node.hasHeatingOil === true);
    }
    if (selectedOfferingProducts.includes(translation('HeatingEquipment'))) {
      result = result?.filter((data) => data.node.hasHeatingEquipment === true);
    }
    if (selectedOfferingServices.includes(translation('Showers'))) {
      result = result?.filter((data) => data.node.hasShowers === true);
    }
    if (selectedOfferingServices.includes(translation('Restroom'))) {
      result = result?.filter((data) => data.node.hasRestrooms === true);
    }
    if (selectedOfferingServices.includes(translation('Wi-Fi'))) {
      result = result?.filter((data) => data.node.hasWifi === true);
    }
    if (selectedOfferingServices.includes(translation('Parking'))) {
      result = result?.filter((data) => data.node.hasParking === true);
    }
    if (selectedOfferingServices.includes(translation('Restaurant'))) {
      result = result?.filter((data) => data.node.hasRestaurant === true);
    }
    if (selectedOfferingServices.includes(translation('ConvenienceStore'))) {
      result = result?.filter((data) => data.node.hasConvenienceStore === true);
    }
    if (selectedOfferingServices.includes(translation('LunchCounter'))) {
      result = result?.filter((data) => data.node.hasLunchCounter === true);
    }
    if (selectedOfferingServices.includes(translation('DriversLounge'))) {
      result = result?.filter((data) => data.node.hasDriversLounge === true);
    }
    if (selectedOfferingServices.includes(translation('Multiservices'))) {
      result = result?.filter((data) => data.node.hasMultiServices === true);
    }

    setLocationsData(result);
    setLat(parseFloat(locationsData[0]?.node?.latitude));
    setLng(parseFloat(locationsData[0]?.node?.longitude));
  }, [
    selectedProvince,
    showLocalBranchesMarkers,
    showUltramarCardlockMarkers,
    showPipelineCardlockMarkers,
    selectedOfferingProducts,
    selectedOfferingServices,
  ]);

  const handleApiLoaded = (map, maps) => {
    const styles = [
      {
        featureType: 'water',
        elementType: 'geometry.fill',
        stylers: [{ color: '#99dbf6' }],
      },
    ];

    // eslint-disable-next-line no-undef
    const styledMap = new google.maps.StyledMapType(styles, {
      name: 'Styled Map',
    });
    map.mapTypes.set('map_style', styledMap);
    map.setMapTypeId('map_style');
  };

  console.log('locationQueryData:: ', locationQueryData);
  return typeof window === 'undefined' ? (
    <>
      <Helmet>
        <title>{translation('Locations') + ' | Ultramar'}</title>
        <link
          rel="alternate"
          href={addTrailingSlash(
            process.env.GATSBY_DOMAIN_URL + '/en/locations'
          )}
          hreflang="en-ca"></link>
        <link
          rel="alternate"
          href={addTrailingSlash(process.env.GATSBY_DOMAIN_URL + '/fr/sites')}
          hreflang="fr-ca"></link>
        <meta property="og:image" content={ogLogo}></meta>
        <meta property="twitter:image" content={ogLogo}></meta>
      </Helmet>
      <Styled.LocationTopClearFix>
        <Styled.LocationsTopFilter
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-once="true">
          <Styled.LocationsTopFilterH2
            title="Open/Close Filter"
            onClick={() => setShowLocationTypes(!showLocationTypes)}>
            {translation('LocationType')}
            <Styled.LocationsTopFilterH2Img
              $open={showLocationTypes}
              src={IconArrowYellowRight}
              alt="Open/Close Filter"
            />
          </Styled.LocationsTopFilterH2>
          <>
            {showLocationTypes && (
              <Styled.LocationsTopFilterInnerBrands>
                <Styled.LocationsTopFilterInnerRow>
                  <Styled.LocationsTopFilterInnerRowLabelBranch>
                    <Styled.LocationsTopFilterInnerRowLabel
                      onClick={() =>
                        setShowLocalBranchesMarkers(!showLocalBranchesMarkers)
                      }>
                      <Styled.LocationsTopFilterInnerRowLabelSpan
                        $checked={showLocalBranchesMarkers}>
                        {translation('LocalBranch')}
                      </Styled.LocationsTopFilterInnerRowLabelSpan>
                    </Styled.LocationsTopFilterInnerRowLabel>
                  </Styled.LocationsTopFilterInnerRowLabelBranch>
                </Styled.LocationsTopFilterInnerRow>
                <Styled.LocationsTopFilterInnerRow>
                  <Styled.LocationsTopFilterInnerRowLabelcardlockUM>
                    <Styled.LocationsTopFilterInnerRowLabel
                      onClick={() =>
                        setShowUltramarCardlockMarkers(
                          !showUltramarCardlockMarkers
                        )
                      }>
                      <Styled.LocationsTopFilterInnerRowLabelSpan
                        $checked={showUltramarCardlockMarkers}>
                        {translation('UltramarCardlock')}
                      </Styled.LocationsTopFilterInnerRowLabelSpan>
                    </Styled.LocationsTopFilterInnerRowLabel>
                  </Styled.LocationsTopFilterInnerRowLabelcardlockUM>
                </Styled.LocationsTopFilterInnerRow>
                <Styled.LocationsTopFilterInnerRow>
                  <Styled.LocationsTopFilterInnerRowLabelCardlockPC>
                    <Styled.LocationsTopFilterInnerRowLabel
                      onClick={() =>
                        setShowPipelineCardlockMarkers(
                          !showPipelineCardlockMarkers
                        )
                      }>
                      <Styled.LocationsTopFilterInnerRowLabelSpan
                        $checked={showPipelineCardlockMarkers}>
                        {translation('PipelineCardlock')}
                      </Styled.LocationsTopFilterInnerRowLabelSpan>
                    </Styled.LocationsTopFilterInnerRowLabel>
                  </Styled.LocationsTopFilterInnerRowLabelCardlockPC>
                </Styled.LocationsTopFilterInnerRow>
              </Styled.LocationsTopFilterInnerBrands>
            )}
            <Styled.LocationsTopFilterH2
              title="Open/Close Filter"
              onClick={() => setShowChooseOffering(!showChooseOffering)}>
              {translation('ChooseOffering')}
              <Styled.LocationsTopFilterH2Img
                $open={showChooseOffering}
                src={IconArrowYellowRight}
                alt="Open/Close Offerings"
              />
            </Styled.LocationsTopFilterH2>
            {showChooseOffering && (
              <Styled.LocationsTopFilterInnerOfferings>
                <Styled.LocationsTopFilterInnerRowIndent>
                  <Styled.LocationsTopFilterInnerRowIndentH3>
                    {translation('Products')}
                  </Styled.LocationsTopFilterInnerRowIndentH3>
                  {offeringProduct.map((item, index) => {
                    return (
                      <Styled.LocationsTopFilterInnerRowIndentLabel
                        key={index}
                        onClick={() => {
                          if (selectedOfferingProducts.includes(item)) {
                            setSelectedOfferingProducts((products) =>
                              selectedOfferingProducts.filter(
                                (itm, index) => itm !== item
                              )
                            );
                          } else {
                            setSelectedOfferingProducts([
                              ...selectedOfferingProducts,
                              item,
                            ]);
                          }
                        }}
                        $backgroundImage={
                          selectedOfferingProducts.includes(item)
                            ? IconCheckBoxActive
                            : IconCheckBoxInActive
                        }>
                        <Styled.LocationsTopFilterInnerRowIndentSpan>
                          {item}
                        </Styled.LocationsTopFilterInnerRowIndentSpan>
                      </Styled.LocationsTopFilterInnerRowIndentLabel>
                    );
                  })}
                </Styled.LocationsTopFilterInnerRowIndent>
                <Styled.LocationsTopFilterInnerRowIndent>
                  <Styled.LocationsTopFilterInnerRowIndentH3>
                    {translation('Services')}
                  </Styled.LocationsTopFilterInnerRowIndentH3>
                  {offeringServices.map((item, index) => {
                    return (
                      <Styled.LocationsTopFilterInnerRowIndentLabel
                        key={index}
                        onClick={() => {
                          if (selectedOfferingServices.includes(item)) {
                            setSelectedOfferingServices((services) =>
                              selectedOfferingServices.filter(
                                (itm, index) => itm !== item
                              )
                            );
                          } else {
                            setSelectedOfferingServices([
                              ...selectedOfferingServices,
                              item,
                            ]);
                          }
                        }}
                        $backgroundImage={
                          selectedOfferingServices.includes(item)
                            ? IconCheckBoxActive
                            : IconCheckBoxInActive
                        }>
                        <Styled.LocationsTopFilterInnerRowIndentSpan>
                          {item}
                        </Styled.LocationsTopFilterInnerRowIndentSpan>
                      </Styled.LocationsTopFilterInnerRowIndentLabel>
                    );
                  })}
                </Styled.LocationsTopFilterInnerRowIndent>
              </Styled.LocationsTopFilterInnerOfferings>
            )}
          </>
        </Styled.LocationsTopFilter>

        <Styled.LocationsTopSearch
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-delay="200"
          data-aos-once="true">
          <Styled.LocationsTopSearchInput>
            <Styled.LocationsTopSearchInputInput
              ref={input}
              type="text"
              placeholder={translation('Search')}
              onKeyUp={(event) => {
                if (event.key === 'Enter') {
                  setSelectedProvince(locationCountries[0]);
                  searchByCityNameOrPostalCode(event.target.value);
                }
              }}
            />
          </Styled.LocationsTopSearchInput>
          <Styled.LocationsTopSearchSubmit>
            <Styled.LocationsTopSearchSubmitInput
              type="submit"
              value=""
              onClick={() => {
                setSelectedProvince(locationCountries[0]);
                searchByCityNameOrPostalCode(input.current.value);
              }}
            />
          </Styled.LocationsTopSearchSubmit>
        </Styled.LocationsTopSearch>

        <Styled.GoogleMapContainer>
          <GoogleMapReact
            bootstrapURLKeys={{
              key: process.env.GATSBY_GOOGLE_MAP_APIKEY,
              libraries: ['places', 'geometry'],
              region: 'CA',
            }}
            center={{ lat, lng }}
            zoom={zoom}
            yesIWantToUseGoogleMapApiInternals
            onGoogleApiLoaded={({ map, maps }) => handleApiLoaded(map, maps)}>
            {locationsData.map((location, index) => {
              if (location.node.address1) {
                return (
                  <LocationMarker
                    key={`${location.node.id}-${index}`}
                    id={location.node.id}
                    currentMarker={currentMarker}
                    lat={location.node.latitude}
                    showServices={true}
                    lng={location.node.longitude}
                    node={location.node}
                    src={getMarkerIcon(location.node.pinType)}
                    onMarkerClick={(data) => {
                      setCurrentMarker(data.id);
                      if (!isSmallDevice()) {
                        if (zoom !== 10) {
                          setLat(parseFloat(data.lat * 1.02));
                          setLng(parseFloat(data.lng * 1.01));
                        } else {
                          setLat(parseFloat(data.lat * 1.003));
                          setLng(parseFloat(data.lng * 1.002));
                        }
                      } else {
                        if (zoom !== 8) {
                          setLat(parseFloat(data.lat * 1.08));
                          setLng(parseFloat(data.lng * 1));
                        } else {
                          setLat(parseFloat(data.lat * 1.02));
                          setLng(parseFloat(data.lng * 1));
                        }
                      }
                    }}></LocationMarker>
                );
              }
            })}
          </GoogleMapReact>
        </Styled.GoogleMapContainer>
      </Styled.LocationTopClearFix>

      <Styled.MainContainer>
        <Styled.CountriesListContainer>
        {locationCountries.map((item, index) => {
            return (
              <Styled.CountriesListItem
                key={index}
                onClick={() => {
                  setSelectedProvince(item);
              }}
              style={{
                backgroundColor: selectedProvince === item ? 'white' : 'initial',
                color: selectedProvince === item ? '#000000' : '#fff'
              }}
            >
                {item}
              </Styled.CountriesListItem>
            );
          })}
        </Styled.CountriesListContainer>
        <div>
          <LocationTable
            Object={locationDataQuery?.allContentfulLocation?.edges?.filter(
              ({ node }) => node.node_locale === selectedLanguage
            )}
          />
        </div>
      </Styled.MainContainer>
    </>
  ) : (
    <>
      <Helmet>
        <title>{translation('Locations') + ' | Ultramar'}</title>
        <link
          rel="alternate"
          href={addTrailingSlash(
            process.env.GATSBY_DOMAIN_URL + '/en/locations'
          )}
          hreflang="en-ca"></link>
        <link
          rel="alternate"
          href={addTrailingSlash(process.env.GATSBY_DOMAIN_URL + '/fr/sites')}
          hreflang="fr-ca"></link>
      </Helmet>

      <Styled.LocationTopClearFix>
        <Styled.LocationsTopFilter
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-once="true">
          <Styled.LocationsTopFilterH2
            title="Open/Close Filter"
            onClick={() => setShowLocationTypes(!showLocationTypes)}>
            {translation('LocationType')}
            <Styled.LocationsTopFilterH2Img
              $open={showLocationTypes}
              src={IconArrowYellowRight}
              alt="Open/Close Filter"
            />
          </Styled.LocationsTopFilterH2>
          <>
            {showLocationTypes && (
              <Styled.LocationsTopFilterInnerBrands>
                <Styled.LocationsTopFilterInnerRow>
                  <Styled.LocationsTopFilterInnerRowLabelBranch>
                    <Styled.LocationsTopFilterInnerRowLabel
                      onClick={() =>
                        setShowLocalBranchesMarkers(!showLocalBranchesMarkers)
                      }>
                      <Styled.LocationsTopFilterInnerRowLabelSpan
                        $checked={showLocalBranchesMarkers}>
                        {translation('LocalBranch')}
                      </Styled.LocationsTopFilterInnerRowLabelSpan>
                    </Styled.LocationsTopFilterInnerRowLabel>
                  </Styled.LocationsTopFilterInnerRowLabelBranch>
                </Styled.LocationsTopFilterInnerRow>
                <Styled.LocationsTopFilterInnerRow>
                  <Styled.LocationsTopFilterInnerRowLabelcardlockUM>
                    <Styled.LocationsTopFilterInnerRowLabel
                      onClick={() =>
                        setShowUltramarCardlockMarkers(
                          !showUltramarCardlockMarkers
                        )
                      }>
                      <Styled.LocationsTopFilterInnerRowLabelSpan
                        $checked={showUltramarCardlockMarkers}>
                        {translation('UltramarCardlock')}
                      </Styled.LocationsTopFilterInnerRowLabelSpan>
                    </Styled.LocationsTopFilterInnerRowLabel>
                  </Styled.LocationsTopFilterInnerRowLabelcardlockUM>
                </Styled.LocationsTopFilterInnerRow>
                <Styled.LocationsTopFilterInnerRow>
                  <Styled.LocationsTopFilterInnerRowLabelCardlockPC>
                    <Styled.LocationsTopFilterInnerRowLabel
                      onClick={() =>
                        setShowPipelineCardlockMarkers(
                          !showPipelineCardlockMarkers
                        )
                      }>
                      <Styled.LocationsTopFilterInnerRowLabelSpan
                        $checked={showPipelineCardlockMarkers}>
                        {translation('PipelineCardlock')}
                      </Styled.LocationsTopFilterInnerRowLabelSpan>
                    </Styled.LocationsTopFilterInnerRowLabel>
                  </Styled.LocationsTopFilterInnerRowLabelCardlockPC>
                </Styled.LocationsTopFilterInnerRow>
              </Styled.LocationsTopFilterInnerBrands>
            )}
            <Styled.LocationsTopFilterH2
              title="Open/Close Filter"
              onClick={() => setShowChooseOffering(!showChooseOffering)}>
              {translation('ChooseOffering')}
              <Styled.LocationsTopFilterH2Img
                $open={showChooseOffering}
                src={IconArrowYellowRight}
                alt="Open/Close Offerings"
              />
            </Styled.LocationsTopFilterH2>
            {showChooseOffering && (
              <Styled.LocationsTopFilterInnerOfferings>
                <Styled.LocationsTopFilterInnerRowIndent>
                  <Styled.LocationsTopFilterInnerRowIndentH3>
                    {translation('Products')}
                  </Styled.LocationsTopFilterInnerRowIndentH3>
                  {offeringProduct.map((item, index) => {
                    return (
                      <Styled.LocationsTopFilterInnerRowIndentLabel
                        key={index}
                        onClick={() => {
                          if (selectedOfferingProducts.includes(item)) {
                            setSelectedOfferingProducts((products) =>
                              selectedOfferingProducts.filter(
                                (itm, index) => itm !== item
                              )
                            );
                          } else {
                            setSelectedOfferingProducts([
                              ...selectedOfferingProducts,
                              item,
                            ]);
                          }
                        }}
                        $backgroundImage={
                          selectedOfferingProducts.includes(item)
                            ? IconCheckBoxActive
                            : IconCheckBoxInActive
                        }>
                        <Styled.LocationsTopFilterInnerRowIndentSpan>
                          {item}
                        </Styled.LocationsTopFilterInnerRowIndentSpan>
                      </Styled.LocationsTopFilterInnerRowIndentLabel>
                    );
                  })}
                </Styled.LocationsTopFilterInnerRowIndent>
                <Styled.LocationsTopFilterInnerRowIndent>
                  <Styled.LocationsTopFilterInnerRowIndentH3>
                    {translation('Services')}
                  </Styled.LocationsTopFilterInnerRowIndentH3>
                  {offeringServices.map((item, index) => {
                    return (
                      <Styled.LocationsTopFilterInnerRowIndentLabel
                        key={index}
                        onClick={() => {
                          if (selectedOfferingServices.includes(item)) {
                            setSelectedOfferingServices((services) =>
                              selectedOfferingServices.filter(
                                (itm, index) => itm !== item
                              )
                            );
                          } else {
                            setSelectedOfferingServices([
                              ...selectedOfferingServices,
                              item,
                            ]);
                          }
                        }}
                        $backgroundImage={
                          selectedOfferingServices.includes(item)
                            ? IconCheckBoxActive
                            : IconCheckBoxInActive
                        }>
                        <Styled.LocationsTopFilterInnerRowIndentSpan>
                          {item}
                        </Styled.LocationsTopFilterInnerRowIndentSpan>
                      </Styled.LocationsTopFilterInnerRowIndentLabel>
                    );
                  })}
                </Styled.LocationsTopFilterInnerRowIndent>
              </Styled.LocationsTopFilterInnerOfferings>
            )}
          </>
        </Styled.LocationsTopFilter>

        <Styled.LocationsTopSearch
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-delay="200"
          data-aos-once="true">
          <Styled.LocationsTopSearchInput>
            <Styled.LocationsTopSearchInputInput
              ref={input}
              type="text"
              placeholder={translation('Search')}
              onKeyUp={(event) => {
                if (event.key === 'Enter') {
                  setSelectedProvince(locationCountries[0]);
                  searchByCityNameOrPostalCode(event.target.value);
                }
              }}
            />
          </Styled.LocationsTopSearchInput>
          <Styled.LocationsTopSearchSubmit>
            <Styled.LocationsTopSearchSubmitInput
              type="submit"
              value=""
              onClick={() => {
                setSelectedProvince(locationCountries[0]);
                searchByCityNameOrPostalCode(input.current.value);
              }}
            />
          </Styled.LocationsTopSearchSubmit>
        </Styled.LocationsTopSearch>

        <Styled.GoogleMapContainer>
          <GoogleMapReact
            bootstrapURLKeys={{
              key: process.env.GATSBY_GOOGLE_MAP_APIKEY,
              libraries: ['places', 'geometry'],
              region: 'CA',
            }}
            center={{ lat, lng }}
            zoom={zoom}
            yesIWantToUseGoogleMapApiInternals
            onGoogleApiLoaded={({ map, maps }) => handleApiLoaded(map, maps)}>
            {locationsData.map((location, index) => {
              if (location.node.address1) {
                return (
                  <LocationMarker
                    key={`${location.node.id}-${index}`}
                    id={location.node.id}
                    currentMarker={currentMarker}
                    lat={location.node.latitude}
                    showServices={true}
                    lng={location.node.longitude}
                    node={location.node}
                    src={getMarkerIcon(location.node.pinType)}
                    onMarkerClick={(data) => {
                      setCurrentMarker(data.id);
                      if (!isSmallDevice()) {
                        if (zoom !== 10) {
                          setLat(parseFloat(data.lat));
                          setLng(parseFloat(data.lng));
                        } else {
                          setLat(parseFloat(data.lat));
                          setLng(parseFloat(data.lng));
                        }
                      } else {
                        if (zoom !== 8) {
                          setLat(parseFloat(data.lat));
                          setLng(parseFloat(data.lng));
                        } else {
                          setLat(parseFloat(data.lat));
                          setLng(parseFloat(data.lng));
                        }
                      }
                    }}></LocationMarker>
                );
              }
            })}
          </GoogleMapReact>
        </Styled.GoogleMapContainer>
      </Styled.LocationTopClearFix>

      <Styled.MainContainer>
        <Styled.CountriesListContainer className="d-none d-md-block">
          {locationCountries.map((item, index) => {
            return (
              <Styled.CountriesListItem
                key={index}
                onClick={() => {
                  setSelectedProvince(item);
              }}
              style={{
                backgroundColor: selectedProvince === item ? 'white' : 'initial',
                color: selectedProvince === item ? '#000000' : '#fff'
              }}
            >
                {item}
              </Styled.CountriesListItem>
            );
          })}
        </Styled.CountriesListContainer>
        <div className="d-none d-md-block">
          <LocationTable Object={locationsData} />
        </div>
        <Styled.AccordionMainDiv className="d-md-none">
          <Styled.AccordionContainer defaultActiveKey={selectedProvince} flush>
            {locationCountries.map((data, index) => (
              <React.Fragment key={index}>
                <Styled.AccordionItem
                  eventKey={data}
                  onClick={() => setSelectedProvince(data)}>
                  <Styled.AccordionHeader>{data}</Styled.AccordionHeader>
                  <Styled.AccordionBody>
                    <LocationTable Object={locationsData} />
                  </Styled.AccordionBody>
                </Styled.AccordionItem>
              </React.Fragment>
            ))}
          </Styled.AccordionContainer>
        </Styled.AccordionMainDiv>
      </Styled.MainContainer>
    </>
  );
};

export default LocationDefault;
